export default {
  Mentions: 'Menções',
  BrandHealth: 'Saúde da Marca',
};
